<template>
  <div>
    <el-card>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="咨询人姓名" width="180">
        </el-table-column>
        <el-table-column prop="sex" label="性别" width="180"> </el-table-column>
        <el-table-column prop="age" label="年龄"> </el-table-column>
        <el-table-column prop="timer" label="出生日期"> </el-table-column>
        <el-table-column prop="city" label="当前城市"> </el-table-column>
        <el-table-column prop="relationship" label="咨询人关系(是否本人)">
        </el-table-column>
        <el-table-column prop="phone" label="手机号码"> </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          name: "王小虎",
          sex: "男",
          age: 22,
          timer: "2020-06-18",
          city: "无锡市",
          relationship: "本人",
          phone: "13055481572",
        },
      ],
    };
  },
  methods:{
  }
};
</script>

<style>
</style>